import { Navigate } from "react-router-dom";
import lazyWithRetry from "utils/lazyWithRetry";
import RoleBasedRoute from "components/guards/RoleBasedRoute";
import DynamicRouteWrapper from "components/guards/DynamicRouteWrapper";
import { USER_ROLES } from "utils/routePermissions";

// Layout Components
const Homerouting = lazyWithRetry(() => import("layouts/Homerouting"));
const AuthLayout = lazyWithRetry(() => import("layouts/AuthLayout"));
const MainLayout = lazyWithRetry(() => import("layouts/MainLayout"));
const UserLayout = lazyWithRetry(() => import("layouts/UserLayout"));
const FoodVendorLayout = lazyWithRetry(() =>
  import("layouts/FoodVendorLayout")
);
const VendorRootLayout = lazyWithRetry(() =>
  import("layouts/VendorRootLayout")
);
// const RiderLayout = lazyWithRetry(() => import("layouts/RiderLayout"));
// const CompanyLayout = lazyWithRetry(() => import("layouts/CompanyLayout"));
// const CompRiderLayout = lazyWithRetry(() => import("layouts/CompanyRiders"));
// const StarrikUserLayout = lazyWithRetry(() => import("layouts/StarrikUserLayout"));
// const StarrikAdminLayout = lazyWithRetry(() =>
//   import("layouts/StarrikAdminLayout")
// );
const PublicLayout = lazyWithRetry(() => import("layouts/PublicLayout"));
const PrivateLayout = lazyWithRetry(() => import("layouts/PrivateLayout"));
const TUALayout = lazyWithRetry(() =>
  import("pages/tech-unlock-africa/TUALayout")
);
const CreateRequestLayout = lazyWithRetry(() =>
  import("layouts/CreateRequestLayout")
);
const CareerLayout = lazyWithRetry(() => import("pages/career/CareerLayout"));
const WithdrawalHistory = lazyWithRetry(() =>
  import("pages/shared/WithdrawalHistory")
);

// Public Components
const AboutUs = lazyWithRetry(() => import("pages/aboutUs/AboutUs"));
const ContactUs = lazyWithRetry(() => import("pages/contactUs/ContactUs"));
const TermsAndCondition = lazyWithRetry(() =>
  import("components/termsAndConditions/TermsAndCondition")
);
const UserTerms = lazyWithRetry(() =>
  import("components/termsAndConditions/UserTerms")
);
const RiderTerms = lazyWithRetry(() =>
  import("components/termsAndConditions/RiderTerms")
);
const ProductDetails = lazyWithRetry(() =>
  import("pages/shared/product/ProductDetails")
);
const ProductDetailsAdminLayout = lazyWithRetry(() =>
  import("pages/shared/product/ProductDetailsAdminLayout")
);
const VendorDetails = lazyWithRetry(() => import("pages/shared/VendorDetails"));
const NotificationsPage = lazyWithRetry(() =>
  import("pages/notifications/Index")
);

// Auth Pages
const Login = lazyWithRetry(() => import("pages/auth/Login"));
const Signup = lazyWithRetry(() => import("pages/auth/Signup"));
const SignupDemo = lazyWithRetry(() => import("pages/auth/SignupDemo"));
const Register = lazyWithRetry(() => import("pages/auth/Register"));
const RiderRegVal = lazyWithRetry(() => import("pages/auth/RiderRegVal"));
const UserRegVal = lazyWithRetry(() => import("pages/auth/UserRegVal"));
const CompRegVal = lazyWithRetry(() => import("pages/auth/CompRegVal"));
const ResetPassword = lazyWithRetry(() => import("pages/auth/ResetPassword"));
const ForgetPassword = lazyWithRetry(() => import("pages/auth/ForgetPassword"));
const BasicInfoStep = lazyWithRetry(() =>
  import("pages/auth/signup/BasicInfoStep")
);


const OnboardingPage = lazyWithRetry(() =>
  import("pages/onboarding/Index")
);
const CompleteStep = lazyWithRetry(() =>
  import("pages/onboarding/CompleteStep")
);
const OnboardingStep = lazyWithRetry(() =>
  import("pages/onboarding/OnboardingStep")
);
const RoleSelectionStep = lazyWithRetry(() =>
  import("pages/auth/signup/RoleSelectionStep")
);
const VerifyEmail = lazyWithRetry(() => import("pages/auth/VerifyEmail"));
const Action = lazyWithRetry(() => import("pages/auth/Action"));
// const TUARegistrationForm = lazyWithRetry(() =>
//   import("pages/tech-unlock-africa/TUARegistrationForm")
// );

// Index Pages
// const CustomerIndex = lazyWithRetry(() => import("pages/customer/Index"));
// const RiderIndex = lazyWithRetry(() =>
//   import("pages/riders/Index")
// );
// const CompanyRidersIndex = lazyWithRetry(() =>
//   import("pages/riders/Index")
// );
// const CompanyIndex = lazyWithRetry(() => import("pages/company/Index"));
// const VendorIndex = lazyWithRetry(() => import("pages/vendor/Index"));
// const StarrikIndex = lazyWithRetry(() => import("pages/starrik/Index"));
const TUAIndex = lazyWithRetry(() =>
  import("pages/tech-unlock-africa/TUAIndex")
);
// const CompanyBikesIndex = lazyWithRetry(() =>
//   import("pages/company/CompanyBikesIndex")
// );

// const PickupDetails = lazyWithRetry(() => import("pages/shared/create-request/PickupDetails"))
const CreateRequest = lazyWithRetry(() =>
  import("pages/shared/create-request/Index")
);
const ReviewAndPay = lazyWithRetry(() =>
  import("pages/shared/create-request/ReviewAndPay")
);
const DropOffDetails = lazyWithRetry(() =>
  import("pages/shared/create-request/DropOffDetails")
);
// const PickupDetails = lazyWithRetry(() => import('pages/customer/CreateRequestFlow/PickupDetails'));
// const DropoffDetails = lazyWithRetry(() => import('pages/customer/CreateRequestFlow/DropoffDetails'));
// const ReviewAndPay = lazyWithRetry(() => import('pages/customer/CreateRequestFlow/ReviewAndPay'));

// Common Components
const Menu = lazyWithRetry(() => import("pages/shared/menu/Menu"));
const OrdersList = lazyWithRetry(() => import("pages/shared/OrdersList"));
const CheckoutPage = lazyWithRetry(() =>
  import("pages/shared/cart/CheckoutPage")
);
const UserCart = lazyWithRetry(() => import("pages/shared/cart/Cart"));
const UserReferrals = lazyWithRetry(() => import("pages/shared/UserReferrals"));
const BrowseVendors = lazyWithRetry(() =>
  import("pages/shared/browse-vendors/BrowseVendors")
);

const SettingsPage = lazyWithRetry(() => import("pages/shared/Settings"));
const adminComponents = {
  TotalOrders: lazyWithRetry(() => import("pages/starrik/Orders")),
  Users: lazyWithRetry(() => import("pages/starrik/Users")),
  UserDetails: lazyWithRetry(() => import("pages/starrik/UserDetails")),
  Employees: lazyWithRetry(() => import("pages/starrik/Employees")),
  Transactions: lazyWithRetry(() => import("pages/starrik/Transactions")),
  // Add other components as needed
};

//Orders Components
// const RiderOrders = lazyWithRetry(() =>
//   import("pages/riders/Orders")
// );
// const RiderRunningOrders = lazyWithRetry(() =>
//   import("pages/riders/independentRider/RunningOrder")
// );

// const CompanyRiders = lazyWithRetry(() => import("pages/company/Riders"));

// const CompanyRiderOrders = lazyWithRetry(() =>
//   import("pages/riders/Orders")
// );
// const CompanyRiderRunningOrders = lazyWithRetry(() =>
//   import("pages/riders/RunningOrder")
// );

// const VendorOrders = lazyWithRetry(() => import("pages/vendor/Orders"));
const VendorCustomerOrders = lazyWithRetry(() =>
  import("pages/vendor/CustomerOrders")
);

export const routesConfig = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        element: <PublicLayout />,
        children: [
          { index: true, element: <Homerouting /> },
          { path: "about-us", element: <AboutUs /> },
          { path: "contact-us", element: <ContactUs /> },
          { path: "careers", element: <CareerLayout /> },
          {
            path: "techunlockafrica",
            element: <TUALayout />,
            children: [
              { index: true, element: <TUAIndex /> },
              // { path: "register", element: <TUARegistrationForm /> },
            ],
          },
          {
            path: "terms-and-conditions",
            element: <TermsAndCondition />,
            children: [
              { path: "user", element: <UserTerms /> },
              { path: "rider", element: <RiderTerms /> },
            ],
          },

          { path: "onboarding/:role", element: <OnboardingPage />, children: [
            { index: true, element: <OnboardingStep /> },
            { path: "complete", element: <CompleteStep /> },
          ] },

          // Auth routes
          {
            path: "auth",
            element: <AuthLayout />,
            children: [
              { path: "login", element: <Login /> },
              {
                path: "signup",
                element: <Signup />,
              },
              // {
              //   path: "signup",
              //   element: <Signup />,
              //   children: [
              //     { index: true, element: <RoleSelectionStep /> },
              //     { path: ":role/basic-info", element: <BasicInfoStep /> },
              //     { path: ":role/onboarding", element: <OnboardingStep /> },
              //     { path: ":role/complete", element: <CompleteStep /> },
              //   ],
              // },
              { path: "signup-demo", element: <SignupDemo /> },
              { path: "register/:name", element: <Register /> },
              // { path: "rider", element: <RiderRegVal /> },
              // { path: "user", element: <UserRegVal /> },
              // { path: "company", element: <CompRegVal /> },
              { path: "action", element: <Action /> },
              { path: "forgot-password", element: <ForgetPassword /> },
              { path: "verify-email", element: <VerifyEmail /> },
              { path: "reset-password", element: <ResetPassword /> },
            ],
          },
        ],
      },
      {
        element: <PrivateLayout />,
        children: [
          // Shared routes (all authenticated users)
          { path: "product/:productId", element: <ProductDetails /> },
          { path: "vendors/:vendorId", element: <VendorDetails /> },
          { path: "menu/:vendorId/:category", element: <Menu /> },
          { path: "checkout", element: <CheckoutPage /> },
          { path: "my-cart", element: <UserCart /> },
          { path: "browse", element: <BrowseVendors /> },
          { path: "referrals", element: <UserReferrals /> },
          { path: "withdrawals", element: <WithdrawalHistory /> },
          { path: "notifications", element: <NotificationsPage /> },

          // Create request flow
          {
            path: "create-request",
            element: <CreateRequestLayout />,
            children: [
              // {index: true, element: <PickupDetails />},
              { index: true, element: <CreateRequest /> },
              { path: "dropoff", element: <DropOffDetails /> },
              { path: "review", element: <ReviewAndPay /> },
            ],
          },

          // Unified Dashboard Route
          {
            path: "dashboard",
            element: (
              <RoleBasedRoute
                allowedRoles={[
                  USER_ROLES.CUSTOMER,
                  USER_ROLES.VENDOR,
                  USER_ROLES.RIDER,
                  USER_ROLES.INDEPENDENT_RIDER,
                  USER_ROLES.COMPANY_RIDER,
                  USER_ROLES.COMPANY,
                  USER_ROLES.STARRIK,
                ]}
              >
                <DynamicRouteWrapper />
              </RoleBasedRoute>
            ),
          },

          // Unified Orders Route
          {
            path: "orders",
            element: (
              <RoleBasedRoute
                allowedRoles={[
                  USER_ROLES.CUSTOMER,
                  USER_ROLES.VENDOR,
                  USER_ROLES.RIDER,
                  USER_ROLES.INDEPENDENT_RIDER,
                  USER_ROLES.COMPANY_RIDER,
                  USER_ROLES.COMPANY,
                  USER_ROLES.STARRIK,
                ]}
              >
                <DynamicRouteWrapper />
              </RoleBasedRoute>
            ),
            children: [
              // Vendor nested order routes (only accessible when parent renders VendorOrders)
              {
                path: "",
                element: (
                  <RoleBasedRoute allowedRoles={[USER_ROLES.VENDOR]}>
                    <OrdersList />
                  </RoleBasedRoute>
                ),
              },
              {
                path: "customer-orders/:orderId",
                element: (
                  <RoleBasedRoute allowedRoles={[USER_ROLES.VENDOR]}>
                    <VendorCustomerOrders />
                  </RoleBasedRoute>
                ),
              },
            ],
          },

          // Order details route (for customers/vendors to track specific orders)
          {
            path: "orders/:id",
            element: (
              <RoleBasedRoute
                allowedRoles={[
                  USER_ROLES.CUSTOMER,
                  USER_ROLES.VENDOR,
                  USER_ROLES.COMPANY,
                ]}
              >
                <OrdersList />
              </RoleBasedRoute>
            ),
          },

          // Rider-specific routes
          {
            path: "active-orders",
            element: (
              <RoleBasedRoute
                allowedRoles={[
                  USER_ROLES.RIDER,
                  USER_ROLES.INDEPENDENT_RIDER,
                  USER_ROLES.COMPANY_RIDER,
                ]}
              >
                <DynamicRouteWrapper />
              </RoleBasedRoute>
            ),
          },

          {
            path: "my-running-order",
            element: (
              <RoleBasedRoute
                allowedRoles={[
                  USER_ROLES.RIDER,
                  USER_ROLES.INDEPENDENT_RIDER,
                  USER_ROLES.COMPANY_RIDER,
                ]}
              >
                <DynamicRouteWrapper />
              </RoleBasedRoute>
            ),
          },

          // Company routes
          {
            path: "riders",
            element: (
              <RoleBasedRoute
                allowedRoles={[USER_ROLES.COMPANY, USER_ROLES.STARRIK]}
              >
                <DynamicRouteWrapper />
              </RoleBasedRoute>
            ),
          },

          {
            path: "bikes",
            element: (
              <RoleBasedRoute allowedRoles={[USER_ROLES.COMPANY]}>
                <DynamicRouteWrapper />
              </RoleBasedRoute>
            ),
          },

          // Starrik admin routes
          {
            path: "users",
            element: (
              <RoleBasedRoute allowedRoles={[USER_ROLES.STARRIK]}>
                <adminComponents.Users />
              </RoleBasedRoute>
            ),
          },

          {
            path: "users/:id",
            element: (
              <RoleBasedRoute allowedRoles={[USER_ROLES.STARRIK]}>
                <adminComponents.UserDetails />
              </RoleBasedRoute>
            ),
          },

          {
            path: "employees",
            element: (
              <RoleBasedRoute allowedRoles={[USER_ROLES.STARRIK]}>
                <adminComponents.Employees />
              </RoleBasedRoute>
            ),
          },

          {
            path: "transactions",
            element: (
              <RoleBasedRoute allowedRoles={[USER_ROLES.STARRIK]}>
                <adminComponents.Transactions />
              </RoleBasedRoute>
            ),
          },

          // Settings route (shared across all roles)
          {
            path: "settings/*",
            element: (
              <RoleBasedRoute
                allowedRoles={[
                  USER_ROLES.CUSTOMER,
                  USER_ROLES.VENDOR,
                  USER_ROLES.RIDER,
                  USER_ROLES.INDEPENDENT_RIDER,
                  USER_ROLES.COMPANY_RIDER,
                  USER_ROLES.COMPANY,
                  USER_ROLES.STARRIK,
                ]}
              >
                <SettingsPage />
              </RoleBasedRoute>
            ),
          },

          // Backward compatibility redirects - Old role-specific routes
          {
            path: "user/dashboard",
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "vendor/food/dashboard",
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "vendor/general/dashboard",
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "rider/dashboard",
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "company/dashboard",
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "company-rider/dashboard",
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "starrik/dashboard",
            element: <Navigate to="/dashboard" replace />,
          },

          // Redirect vendor orders
          {
            path: "vendor/food/orders",
            element: <Navigate to="/orders" replace />,
          },
          {
            path: "vendor/general/orders",
            element: <Navigate to="/orders" replace />,
          },

          // Redirect rider routes
          {
            path: "rider/active-orders",
            element: <Navigate to="/active-orders" replace />,
          },
          {
            path: "rider/my-running-order",
            element: <Navigate to="/my-running-order" replace />,
          },
          {
            path: "company-rider/active-orders",
            element: <Navigate to="/active-orders" replace />,
          },
          {
            path: "company-rider/my-running-order",
            element: <Navigate to="/my-running-order" replace />,
          },

          // Legacy vendor routes - Keep for now with redirects
          {
            path: "vendor",
            element: <VendorRootLayout />,
            children: [
              {
                path: "food",
                element: <FoodVendorLayout />,
                children: [
                  {
                    path: "dashboard",
                    element: <Navigate to="/dashboard" replace />,
                  },
                  {
                    path: "product/:productId",
                    element: <ProductDetailsAdminLayout />,
                  },
                  {
                    path: "orders",
                    element: <Navigate to="/orders" replace />,
                  },
                  {
                    path: "settings/*",
                    element: <Navigate to="/settings" replace />,
                  },
                ],
              },
              {
                path: "general",
                element: <UserLayout />,
                children: [
                  {
                    path: "dashboard",
                    element: <Navigate to="/dashboard" replace />,
                  },
                  { path: "orders/:id", element: <OrdersList /> },
                  {
                    path: "settings/*",
                    element: <Navigate to="/settings" replace />,
                  },
                ],
              },
            ],
          },

          // Additional backward compatibility redirects
          {
            path: "rider/withdrawals",
            element: <Navigate to="/withdrawals" replace />,
          },
          {
            path: "company-rider/withdrawals",
            element: <Navigate to="/withdrawals" replace />,
          },
          {
            path: "company/riders",
            element: <Navigate to="/riders" replace />,
          },
          { path: "company/bikes", element: <Navigate to="/bikes" replace /> },
          { path: "starrik/users", element: <Navigate to="/users" replace /> },
          {
            path: "starrik/employees",
            element: <Navigate to="/employees" replace />,
          },
          {
            path: "starrik/orders",
            element: <Navigate to="/orders" replace />,
          },
          {
            path: "starrik/transactions",
            element: <Navigate to="/transactions" replace />,
          },

          // Food vendor product management (keep for vendor-specific routes)
          {
            path: "vendor/food/product/:productId",
            element: <ProductDetailsAdminLayout />,
          },
        ],
      },

      // Fallback route
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
];
